import api from '~/store/services/api';
import urlConstants from '~/lib/constants/url.constants';
import { GetAigssResponse } from '~/lib/types/notes/GetAigssResponse';
import { CreateAiSummaryReviewRequest } from '~/lib/types/notes/CreateAiSummaryReviewRequest';
import { HttpRequestMethod } from '~/store';

export const aigssApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAigssByAppointmentId: build.query<GetAigssResponse, string>({
      query: (appointmentExternalId: string) => ({
        url: urlConstants.clinical_data.getAigssByAppointmentId(
          appointmentExternalId,
        ),
      }),
    }),
    createAiSummaryReview: build.mutation<
      { id: string },
      CreateAiSummaryReviewRequest
    >({
      query: (body) => ({
        method: HttpRequestMethod.POST,
        url: urlConstants.clinical_data.postAiSummaryReview,
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetAigssByAppointmentIdQuery,
  useCreateAiSummaryReviewMutation,
} = aigssApi;
